import styled from 'styled-components';

interface CustomerQuestionProps {
  isDesk: boolean;
}

const Wrapper = styled.div`
  padding: 16px 16px 0 16px;
`;

const Content = styled.div<CustomerQuestionProps>`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border: 1px solid #e9e9e9;
  border-radius: 0px 0px 16px 16px;
  margin-bottom: ${({ isDesk }) => (isDesk ? '16px' : '')};
`;

const Title = styled.p<CustomerQuestionProps>`
  font-style: normal;
  font-weight: 600;
  font-size: ${({ isDesk }) => (isDesk ? '16px' : '14px')};
  line-height: 120%;
  padding: 16px;
  color: #666666;
`;

const Header = styled.div<CustomerQuestionProps>`
  border-width: 1px 1px 0px 1px;
  border-style: solid;
  border-color: #e9e9e9;
  border-radius: 16px 16px 0px 0px;
  background: #fafafa;
  margin-top: ${({ isDesk }) => (isDesk ? '' : '16px')};
`;

export { Title, Wrapper, Header, Content };
